import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { ItineraryPage } from './ItineraryPage';
import { ItineraryEditPage } from './ItineraryEditPage';
import * as AuthSelectors from 'store/modules/auth/selectors';
import { useSelector } from 'react-redux';
export interface ItineraryPageRoutingProps extends RouteComponentProps {}

export const ItineraryPageRouting = (props: ItineraryPageRoutingProps) => {
  const isInternalUser = useSelector(AuthSelectors.isInternalUser);
  return (
    <Switch>
      {isInternalUser && (
        <Route path={`${props.match.path}/:bookingUuid/:version/edit`} component={ItineraryEditPage} exact />
      )}
      <Route path={`${props.match.path}/:bookingUuid/:version`} component={ItineraryPage} exact />
    </Switch>
  );
};
